<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.domain = Endpoints.domain;
        //payload.filter();

    },
    methods:{
         filter: function(){
            $('#spinner').modal('toggle');
            let state = this;
            state.items = [];
            setTimeout(async function(){
                console.log('FILTERS', state.filters)
                try {                
                    let truckers = (await Request.do(state, 'POST', Request.getDefaultHeader(state),state.filters, `${Endpoints.systemUsers.filter}`));                
                    state.items = truckers.data.results[0].paginatedResults;
                    
                } catch(err) {
                    console.log(err)
                    console.log('Retentando!!')
                    state.filter();
                }
                $('#spinner').modal('toggle');
            }, 500);
            
            this.json_data= this.items;
         
        },
        selectItem: function(item){
            let copy = JSON.parse(JSON.stringify(item));
            copy.password = null;
            if(copy.customerUser.company)
                copy.customerUser.company = copy.customerUser.company._id;
            this.$emit('load-item', copy);
        }, 
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },

        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
